import React, { Component, Fragment } from 'react';
import { Snackbar, Button, HSpacer, VSpacer } from 'sm-react-components';
import { withStyles } from '@material-ui/core/styles';

import LinearProgress from '@material-ui/core/LinearProgress';
import { CardContent, Typography, Tabs, Tab, Grid } from '@material-ui/core';

import mixpanel, { Events as MPEvents } from '../../infrastructure/mixpanel';
import * as requests from '../../infrastructure/requests';
import * as formatters from '../formatters';
import Error from '../components/Error';
import PageContainer from '../container/PageContainer';
import Quota from './Quota';
import Key from '../../static/svg/Key';
import KeyStatistics from '../container/KeyStatistics';
import PlaceSummary from '../components/PlaceSummary';
import Assignment from '@material-ui/icons/Assignment';

const styles = {
    keyimage: {
        color: 'gray',
        width: '50%',
        height: '50%',
        marginTop: 'auto',
        marginBottom: 'auto'
    },
    divKeyContainer: {
        width: '100px',
        height: '100px',
        backgroundColor: 'Gainsboro',
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center'
    },
    divTabs: {
        minHeight: '400px'
    }
};
class KeyDetails extends Component {
  state = {
      loading: false,
      data: undefined,
      error: undefined,
      successCopy: false,
      tabSelected: 0
  };

  async load() {
      const { id } = this.props;
      this.setState({ loading: true });
      try {
          this.setState({
              loading: false,
              data: await requests.getKey(id)
          });
      } catch (error) {
          this.setState({
              error: error.message,
              loading: false
          });
      }
  }

  componentDidMount() {
      this.load();
      mixpanel.track(MPEvents.CONSOLE_KEYS_OPEN_KEY_DETAILS, {
          id: this.props.id
      });
  }

  handleTabChange = (event, value) => {
      this.setState({
          tabSelected: value
      });
  };

  handleClickButtonCopy = () => {
      const { data } = this.state;
      const el = document.createElement('textarea');
      el.value = data.key;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.setState({ successCopy: true });
  };

  render() {
      const { loading, error, data, successCopy, tabSelected } = this.state;
      const { id, classes } = this.props;
      return (
          <PageContainer>
              <Snackbar
                  open={successCopy}
                  variant="success"
                  autoHideDuration={3000}
                  onClose={() => this.setState({ successCopy: false })}
                  vertical="top"
                  horizontal="center"
                  message="Key copied to clipboard succesfully!"
              />
              <CardContent>
                  {loading && <LinearProgress />}
                  {error && <Error message={error} />}
                  {!loading && data && (
                      <Fragment>
                          <Grid container justify="center">
                              <Typography variant="h1" style={{ marginBottom: '5px' }}>
                                  {data.name}
                              </Typography>
                          </Grid>
                          <Grid container justify="center">
                              <Tabs
                                  value={tabSelected}
                                  onChange={this.handleTabChange}
                                  indicatorColor="primary"
                                  textColor="primary"
                              >
                                  <Tab key="tab_overview" label="OVERVIEW" />
                                  <Tab key="tab_quota" label="QUOTA" />
                                  <Tab key="tab_places" label="PLACES" />
                  })}
                              </Tabs>
                          </Grid>
                          <VSpacer small />
                          {tabSelected === 0 && (
                              <div className={classes.divTabs}>
                                  <Grid container>
                                      <Grid item lg={1}>
                                          <div className={classes.divKeyContainer}>
                                              <Key className={classes.keyimage} />
                                          </div>
                                      </Grid>
                                      <Grid item lg={11}>
                                          <Typography variant="h4" style={{ margin: '5px 0px' }}>
                        Key
                                          </Typography>
                                          <Typography variant="body1" style={{ margin: '5px 0px' }}>
                                              {data.key}
                                          </Typography>
                                          <VSpacer medium />
                                          <Button
                                              color="primary"
                                              variant="contained"
                                              onClick={this.handleClickButtonCopy}
                                          >
                                              <Assignment />
                                              <HSpacer small />
                        COPY KEY
                                          </Button>
                                          {formatters.tags(data.tags)}
                                      </Grid>
                                  </Grid>
                                  <VSpacer />
                                  <VSpacer />
                                  <Typography variant="h2">Statistics</Typography>
                                  <VSpacer />
                                  <KeyStatistics filters={{ keys: [id] }} />
                              </div>
                          )}
                          {tabSelected === 1 && (
                              <div className={classes.divTabs}>
                                  <Typography variant="h4">Quota</Typography>
                                  <VSpacer />
                                  <Quota id={id} />
                              </div>
                          )}
                          {tabSelected === 2 && data && (
                              <div className={classes.divTabs}>
                                  <PlaceSummary keyData={data} />
                              </div>
                          )}
                      </Fragment>
                  )}
              </CardContent>
          </PageContainer>
      );
  }
}

export default withStyles(styles)(KeyDetails);
